import { useClient } from './client'

import { useMutation } from '@tanstack/vue-query'

export const useRefreshJwt = () => {
   const client = useClient()

   return useMutation({
      mutationFn: async () => {
         await client.auth.refreshSession()
      },
   })
}
